/*

    App themes are exported from here and into Sass via Webpack.

*/

const lightTheme = require('./themes/theme-light');
const darkTheme = require('./themes/theme-dark');
const clientThemes = require('../client/data/app-themes.client');

module.exports = {
    light: lightTheme,
    dark: darkTheme,
    ...clientThemes,
};
